module.exports = __webpack_public_path__ + "img/dhl_icon.af72d4d2.svg";